import UseCases from './UseCases';

export default UseCases;
